//import liraries
import React, { Component, useState, useEffect } from 'react';
import { View, Text, ScrollView, TouchableOpacity, Image } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import CHeader from '../../common/CHeader';
import CImage from '../../common/CImage';
import CText from '../../common/CText';
import { COLORS } from '../../constant';
import CDocxViewer from '../../common/CDocxViewer';
// create a component
const MPBenefitDetails = (props) => {
    const styles = useStyles();
    const [tncModalVisible, setTncModalVisible] = useState(false);

    return (
        <View style={styles.container}>
            <CHeader showBack onPress={() => props.setActiveScreen("benefits")} title={"Avail MAX Benefits"} />

            <View style={styles.conetWrapper}>
                <View>
                    <CText.headerDesc style={{ marginBottom: 15 }}>{"FASTag MAX Support"}</CText.headerDesc>

                    <View style={styles.tabBanner}>
                        <Image
                            source={require("../../assets/images/maxpro/mp_benefits_details_banner_tab.png")}
                            style={styles.mpBanner}
                        />
                    </View>
                </View>

                <View style={styles.contentWidget}>
                    <CText.headerDesc style={{ marginBottom: 15 }}>{"Know more about FASTag MAX"}</CText.headerDesc>

                    <View
                        style={styles.gradBoxTwo}
                    >

                        <CImage.FaqCtaImg></CImage.FaqCtaImg>
                        <View
                            style={{
                                flex: 1,
                                borderRadius: 15,
                                paddingRight: 20,
                                paddingLeft: 0,
                                paddingTop: 20
                            }}
                        >
                            <View style={styles.gradBoxOneWidget}>

                                <Text
                                    style={{ fontWeight: '600' }}
                                >
                                    {"FASTag MAX FAQ's"}
                                </Text>
                                <Text style={[styles.gradSubTitle, { fontSize: 11, marginVertical: 5, color: "#010102" }]}>
                                    {"Read frequently asked question related to FASTag MAX"}
                                </Text>
                            </View>
                            <TouchableOpacity
                                style={styles.forwardLink}
                                onPress={() => {
                                    props.setActiveScreen("benefitFaq")
                                }}
                            >
                                <Image
                                    source={require("../../assets/images/icon_forward.png")}
                                    style={{ width: 14, height: 15, marginLeft: 7 }}
                                />
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={[styles.gradBoxOne]}>
                        <Image
                            source={require("../../assets/images/Amitab.png")}
                            style={{ width: "30%", height: "100%", resizeMode: "cover" }}
                        />
                        <View
                            style={styles.cardContent}
                        >
                            <View style={styles.gradBoxOneWidget}>
                                <CText.basicInformationSubHeader>{"Terms & Conditions"}</CText.basicInformationSubHeader>
                                <CText.tncText>
                                    {"Read all FASTag MAX terms and conditions "}
                                </CText.tncText>

                            </View>
                            <View style={{ left: 20 }}>
                                <TouchableOpacity
                                    style={styles.forwardLink}
                                    onPress={() => {
                                        setTncModalVisible(true);
                                    }}
                                >
                                    <Image
                                        source={require("../../assets/images/icon_forward.png")}
                                        style={{ width: 14, height: 15, marginLeft: 7 }}
                                    />
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            {tncModalVisible && <CDocxViewer type = "FF_PROMAX_TNC" visibility={setTncModalVisible}/>}
        </View>
    );
};

// define your styles
const useStyles = CreateResponsiveStyle(
    {
        container: {
            width: "100%",
        },
        conetWrapper: {
            flexDirection: 'row',
            marginHorizontal: 25,
            marginVertical: 25
        },
        mpdetailsTextStyle: {
            width: "80%"
        },
        contentWidget: {
            paddingLeft: 30,
        },
        backBtn: {
            width: 150,
            backgroundColor: COLORS.white,
            borderWidth: 1,
            borderColor: COLORS.red,
            marginRight: 15,
            marginTop: 12,
            color: COLORS.red,
            height: 36,
            borderRadius: 23,
            alignItems: 'center',
            justifyContent: 'center'
        },
        overlayViewStyle: {
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            minHeight: 500,
            top: 0,
            left: 0,
            borderRadius: 10,
            alignItems: "center",
        },
        overlayContentStyle: {
            width: "80%",
            height: 400,
            backgroundColor: "white",
            borderRadius: 15,
            alignSelf: "center",
            justifyContent: "center",
            marginVertical: 30

        },
        pdfViewStyle: {
            padding: 0,
            height: 320,
            width: "100%",
        },
        gradBoxOne: {
            flexDirection: "row",
            width: 320,
            height: 135,
            overflow: 'hidden',
            backgroundImage:
                "linear-gradient(126deg, #ccc 12%, #e9e9e9 90%)", borderRadius: 10
        },
        gradBoxTwo: {
            flexDirection: "row",
            backgroundImage:
                "linear-gradient(126deg, #cae7d0 12%, #8ccbba 90%)",
            borderRadius: 10,
            marginBottom: 15,
            height: 135,
            width: 320,
            overflow: 'hidden'
        },
        mpBanner: {
            width: 300,
            height: 195,
            resizeMode: 'contain'

        },
        forwardLink:{
            height: 30,
            width: 30,
            borderRadius: 20,
            backgroundColor: "white",
            alignSelf: 'flex-end',
            justifyContent: "center",
        },
        cardContent:{
            flex: 1,
            borderRadius: 15,
            paddingHorizontal: 40,
            paddingVertical: 20,
        }
    },

    {
        [DEVICE_SIZES.XL]: {
            container: {},
        },
        [DEVICE_SIZES.LG]: {
        },
        [DEVICE_SIZES.MD]: {
            container: {
                flexDirection: "column",
            },

            contentWidget: {
                width: "100%",
                paddingLeft: 0
            },
            conetWrapper: {
                flexDirection: "column",
                marginHorizontal: 15
            },
            gradBoxOne: {
                width: '100%',
                height: 140
            },
            gradBoxTwo: {
                width: '100%',
                height: 140
            },
            mpBanner: {
                maxWidth: '100%',
                height: 229,
                resizeMode: 'cover',
                width: '100%',
                marginBottom: 20
            }

        },
        [DEVICE_SIZES.SM]: {
            container: {
                flexDirection: "column",
            },
            conetWrapper: {
                flexDirection: "column",
                marginHorizontal: 15
            },
            contentWidget: {
                paddingLeft: 0
            },
        },
        [DEVICE_SIZES.XS]: {
            container: {
                width: "100%",
            },
            conetWrapper: {
                flexDirection: "column",
                marginHorizontal: 15
            },
            contentWidget: {
                marginTop: 30,
                paddingLeft: 0
            },
            overlayContentStyle: {
                width: "90%",
            },
            gradBoxOne: {
                width: '100%',
                height: 140
            },
            gradBoxTwo: {
                width: '100%',
                height: 140
            },
        },

    }
);

//make this component available to the app
export default MPBenefitDetails;
